import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'autocompleteSlice',
    standalone: false
})
export class AutocompleteSlicePipe implements PipeTransform {
  transform(
    maskText: string | string[],
    inputValue: string,
    configuration: string = 'default'
  ): string {
    let charArray = [];
    let maskedText = '';

    const arrMaskText = Array.isArray(maskText) ? maskText : [maskText];

    // switch (configuration) {
    //   case 'email':
    //     charArray = ['@', '.'];
    //     let index = 0;

    //     if (inputValue) {
    //       let inputSubstrings = inputValue.split(charArray[0]);

    //       if (inputSubstrings.length == 2) {
    //         index++;
    //         inputSubstrings = [
    //           inputSubstrings[0],
    //           ...inputSubstrings[1].split(charArray[1]),
    //         ];
    //       }
    //       if (inputSubstrings.length == 3) {
    //         index++;
    //       }

    //       inputSubstrings.forEach((substring) => {
    //         if (substring.length) {
    //           index++;
    //         }
    //       });
    //     }
    //     maskedText = maskText.slice(index);
    //     break;

    //   default:
    //     maskedText = maskText.slice(inputValue?.length || 0);
    // }

    return arrMaskText[0];
  }
}
